import React from 'react'
import Layout from '@components/Layout'
import { graphql } from 'gatsby'
import { getHrefLangUrls, handleSEO } from '@utils'
import TitleAndMetaTags from '@components/TitleAndMetaTags'
import EventsDetailContent from '@sections/EventsDetailContent'

const EventsDetail = ({ data, pageContext }) => {
  return (
    <Layout {...pageContext} contentType="event">
      <EventsDetailContent {...data} next={pageContext?.nextEntries} />
    </Layout>
  )
}

export default EventsDetail

export const query = graphql`
  query eventsDetailV2(
    $contentful_id: String!
    $node_locale: String!
    $displayOnSitesAsNodeLocales: [String!]
  ) {
    parentPage: contentfulPage(
      contentful_id: { eq: "1iNTN1YVOUMwz2QNZmudo3" }
      node_locale: { eq: $node_locale }
    ) {
      ...basePageFields
      parentId: contentful_id
    }
    event: contentfulEvent(
      contentful_id: { eq: $contentful_id }
      node_locale: { eq: $node_locale }
    ) {
      ...baseEventFields
      type
      timeZone
      eventStart
      eventEnd
      location
      street
      city
      state
      country
      registrationLink
      signUpForFutureEventsLink
      videoOrAudioTitle
      videoOrAudioFile {
        file {
          url
        }
      }
      associatedPracticeAreas {
        ...basePracticeAreaFields
      }
      associatedProfessionals {
        ...baseProfessionalFields
        offices {
          ...baseOfficeFields
        }
        image {
          ...assetBase
        }
      }
      # featuredImage {
      #   ...assetBase
      # }
      contentHtml: childContentfulEventContentHtmlJsonNode {
        useHTMLField
        html
      }
      content {
        raw
        references {
          ...assetBase
          ...articleLinkFields
          ...articleCategoryLinkFields
          ...eventLinkFields
          ...filterPageLinkFields
          ...newsLinkFields
          ...officeLinkFields
          ...pageLinkFields
          ...practiceAreaLinkFields
          ...professionalLinkFields
          ...moduleAccordion
          ...moduleMediaEmbed
          ...moduleList
        }
      }
      seo {
        ...seoMetadata
      }
      eventTimes {
        eventStart
        eventEnd
        timeZone
      }
    }
    currentPageWithAllLocales: allContentfulEvent(
      filter: {
        node_locale: { in: $displayOnSitesAsNodeLocales }
        contentful_id: { eq: $contentful_id }
      }
    ) {
      nodes {
        slug
        node_locale
      }
    }
  }
`

export const Head = ({
  data: { event, currentPageWithAllLocales },
  pageContext: { displayLocale, parentPages, localizedSlug },
}) => {
  const { title, content, contentHtml, associatedPracticeAreas, seo } = event

  const { seoTitle, seoDescription, seoKeywords, seoImage } = handleSEO(
    seo,
    {
      title: title,
      content: content,
      contentHtml: contentHtml,
      practiceAreas: associatedPracticeAreas,
    },
    displayLocale
  )

  const hrefLangUrls = getHrefLangUrls(
    currentPageWithAllLocales?.nodes,
    parentPages
  )

  return (
    <TitleAndMetaTags
      hrefLangUrls={hrefLangUrls}
      title={seoTitle}
      description={seoDescription}
      keywords={seoKeywords}
      image={seoImage}
      canonicalSlug={localizedSlug}
      usDefault={seo?.enUsCanonicalUrl}
      noIndex={seo?.noIndex}
      noArchive={seo?.noArchive}
    />
  )
}
